export const tjenestePath: string = '?tjeneste=skjemautfyller';

export interface RedirectParams {
  redirectUrl?: string;
  contextParameter?: string;
  documentGuid?: string;
  returnUrl?: string;
  taskId?: string;
  resourceId?: string;
  resourceIdType?: string;
}

export const meldinger_path = '/meldinger/samtale/';
export const oppgave_path = '/oppgave/';
export const oppgaver_path = '/oppgaver/';
export const oppgaver_string = 'oppgaver';

export const breadcrumbText_oppgaver = 'Oppgave';

export const PARAM_RETUR_URL = 'retururl';
export const PARAM_RETUR_URL_TEKST = 'retururltekst';
